export default __webpack_public_path__ + "static/media/(25).c6ebb4c0.jpeg";